import React from 'react'
import Navbar from '../componenst/Navbar'
import Compmain from '../componenst/Layanan/Compmain'
import { useParams } from 'react-router-dom'

export default function Layanan() {
    const { kode_booking, kode_booking2 } = useParams();
    return (
        <div>
            <Navbar judul="Layanan" aicon="true" />
            <div className='container'>
                <br />
                <Compmain kodebooking={kode_booking} kodebooking2={kode_booking2} />
            </div>
        </div>
    )
}
